const postMessageToPreview = (data) => {
	document
		.getElementById('kozmikPreviewFrame')
		.contentWindow.postMessage(data, '*')
}

export default postMessageToPreview
